import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { fileUrl, initials } from "@/lib/api";
import { cn } from "@/lib/utils";

export const EmpAvatar = ({ emp, size = "h-10 w-10", className }) => {
  const name = emp?.full_name || emp?.name || "?";
  return (
    <Avatar className={cn(size, "rounded-md border border-border", className)}>
      {emp?.photo_file_id && <AvatarImage src={fileUrl(emp.photo_file_id)} alt={name} className="object-cover" />}
      <AvatarFallback className="rounded-md bg-primary/10 text-primary font-semibold text-sm">
        {initials(name)}
      </AvatarFallback>
    </Avatar>
  );
};
